import { PageDiffusionModelsViewsDesktop } from './page_diffusion_models_views_desktop';
import { WatcherDiffusionModelsLoadUD } from './watchers/watcher_diffusion_models_load_ud';
import { WatcherSlugPageDiffusionModels } from './watchers/watcher_slug_page_diffusion_models';

export const PageDiffusionModels = () => (
  <>
    <WatcherSlugPageDiffusionModels />
    <WatcherDiffusionModelsLoadUD />

    <PageDiffusionModelsViewsDesktop />
  </>
);
